/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkTimeCalculationEligibility} from '../api'

export const useMutationCheckTimeCalculationEligibility = createReactQueryMutationHook('checkTimeCalculationEligibility', checkTimeCalculationEligibility)
